// extracted by mini-css-extract-plugin
export default {"h1":"about_h1__ZCV-T"};